import { BaseApi } from '../../api/apiBase'
import { CustomPageListItem, CustomPageDetail } from '../types/customPage'

class CustomPagesApi extends BaseApi {
    async getCustomPages(eventSlug: string): Promise<CustomPageListItem[]> {
        // The route expects /api/portal/events/:slug/content_pages
        // Use getSimpleJson for non-JSON:API responses
        const response = await this.getSimpleJson<{ data: CustomPageListItem[] }>(
            `/events/${eventSlug}/content_pages`
        )
        return response.data || []
    }

    async getCustomPage(eventSlug: string, pageSlug: string): Promise<CustomPageDetail> {
        // The route expects /api/portal/events/:slug/content_pages/:page_slug
        // Use getSimpleJson for non-JSON:API responses
        const response = await this.getSimpleJson<{ data: CustomPageDetail }>(
            `/events/${eventSlug}/content_pages/${pageSlug}`
        )
        return response.data
    }
}

export const customPagesApi = new CustomPagesApi()